import React, { useContext, useEffect, useState } from 'react';
import { object } from 'prop-types';

import exportWithBoundary from '../../../../helpers/exportWithBoundary';
import { JobMapContext } from '../JobMapContext';
import useJobMapJobPosting from '../useJobMapJobPosting';
import { JobMapMediaContainer } from './styles';

function JobMapJobMedia({ jobPosting }) {
  const { jobMapId, mediaMode } = useContext(JobMapContext);

  if (mediaMode === 'no_media') return null;

  let showStreetView = false;
  let address = null;

  if (mediaMode === 'street_view' && jobPosting.locations.length > 0) {
    const addressParts = [];
    const loc = jobPosting.locations[0];
    if (loc.street_address) addressParts.push(`${loc.street_address},`);
    addressParts.push(loc.canonical_name);
    if (loc.postal_code) addressParts.push(loc.postal_code);
    if (
      loc.country_code !== 'US' &&
      loc.country_code.indexOf('United States') < 0
    )
      addressParts.push(loc.country_code);
    address = addressParts.join(' ');
    if (
      jobPosting.locations.length > 0 &&
      jobPosting.locations[0].street_address &&
      jobPosting.locations[0].street_address.length > 0
    ) {
      showStreetView = true;
    }
  }

  let url =
    mediaMode === 'street_view'
      ? 'https://static.careerarc.com/polaris/no-street-view.jpg'
      : '';
  if (showStreetView && address && address.length > 0) {
    url = `https://maps.googleapis.com/maps/api/streetview?key=${encodeURIComponent(
      'AIzaSyBxWPGy-pjLdSkOBjEIcgkwLuzivzfTDd4'
    )}&size=400x180&location=${encodeURIComponent(address)}&sensor=false`;
  }

  const [imageUrl, setImageUrl] = useState(url);
  let jobMapJobPosting;

  if (mediaMode === 'assets') {
    jobMapJobPosting = useJobMapJobPosting(jobMapId, jobPosting.id, 'extended');
  }

  useEffect(() => {
    if (jobMapJobPosting.data && jobMapJobPosting.data.sample_media) {
      setImageUrl(jobMapJobPosting.data.sample_media);
    }
  }, [jobMapJobPosting.data]);

  return <JobMapMediaContainer imageUrl={imageUrl} />;
}

JobMapJobMedia.propTypes = {
  jobPosting: object.isRequired,
};

function JobMapJobMediaFallback() {
  return <JobMapMediaContainer />;
}

export default exportWithBoundary(JobMapJobMedia, JobMapJobMediaFallback);
